module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-media-list-editor"
  }, [_c('form', {
    staticClass: "action-buttons",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('label', {
    staticClass: "form-button"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": _vm.allowedImageTypes.join(',')
    },
    on: {
      "change": _vm.addImageMedia
    }
  }), _vm._v("\n                Add Image\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "form-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$modal.show('add-video-modal')
      }
    }
  }, [_vm._v("\n                Add Vimeo\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "form-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$modal.show('add-sketchfab-modal')
      }
    }
  }, [_vm._v("\n                Add Sketchfab\n            ")]), _vm._v(" "), _c('label', {
    staticClass: "form-button"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.addMarmosetMedia
    }
  }), _vm._v("\n                Add Marmoset Viewer\n            ")]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "add-video-modal",
      "classes": "v-modal"
    },
    on: {
      "before-open": _vm.resetAddVideoUrl
    }
  }, [_c('section', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("\n                            Add Vimeo\n                            "), _c('button', {
    staticClass: "clear-button float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('add-video-modal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addVideoMedia($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Vimeo URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addVideoUrl),
      expression: "addVideoUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Video URL"
    },
    domProps: {
      "value": (_vm.addVideoUrl)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.addVideoUrl = $event.target.value
      }, _vm.updateAddVideoUrlInfo]
    }
  })]), _vm._v(" "), (!!_vm.addVideoUrlError) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("URL is invalid")])]) : _vm._e(), _vm._v(" "), (!!_vm.addVideoUrlInfo) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Add Vimeo"
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "add-sketchfab-modal",
      "classes": "v-modal"
    },
    on: {
      "before-open": _vm.resetAddSketchfabUrl
    }
  }, [_c('section', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("\n                            Add Sketchfab\n                            "), _c('button', {
    staticClass: "clear-button float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$modal.hide('add-sketchfab-modal')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addSketchfabMedia($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sketchfab URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addSketchfabUrl),
      expression: "addSketchfabUrl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "https://sketchfab.com/models/..."
    },
    domProps: {
      "value": (_vm.addSketchfabUrl)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.addSketchfabUrl = $event.target.value
      }, _vm.updateAddSketchfabUrlInfo]
    }
  })]), _vm._v(" "), (!!_vm.addSketchfabUrlError) ? _c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("URL is invalid")])]) : _vm._e(), _vm._v(" "), (!!_vm.addSketchfabUrlInfo) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Add Sketchfab"
    }
  })]) : _vm._e()])])])])], 1)]), _vm._v(" "), (_vm.media.length > 0) ? _c('ol', {
    staticClass: "media-list"
  }, _vm._l((_vm.media), function(mediaItem, index) {
    return _c('li', {
      key: mediaItem.url,
      staticClass: "media-col",
      attrs: {
        "draggable": !_vm.disabled
      },
      on: {
        "dragstart": _vm.dndMedia_start,
        "dragenter": _vm.dndMedia_enter,
        "dragleave": _vm.dndMedia_leave,
        "dragover": _vm.dndMedia_over,
        "dragend": _vm.dndMedia_end,
        "drop": _vm.dndMedia_drop
      }
    }, [_c('div', {
      staticClass: "media"
    }, [_c('button', {
      staticClass: "clear-button",
      on: {
        "click": function($event) {
          _vm.removeMedia(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('div', {
      staticClass: "preview"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('img', {
      attrs: {
        "src": mediaItem.thumbnailUrl,
        "draggable": "false"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-fields"
    }, [_c('label', [_vm._v("Caption (one word) *")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (mediaItem.caption),
        expression: "mediaItem.caption"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Example: wide, closeup, boots, head, gun",
        "cols": "40",
        "rows": "2"
      },
      domProps: {
        "value": (mediaItem.caption)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          mediaItem.caption = $event.target.value
        }
      }
    }), _vm._v(" "), _c('label', [_vm._v("Discipline(s)")]), _vm._v(" "), (mediaItem.disciplines) ? _c('select', {
      staticClass: "form-control",
      on: {
        "change": function($event) {
          _vm.addDiscipline($event, index)
        }
      }
    }, [_c('option', {
      attrs: {
        "default": "",
        "disabled": "",
        "selected": ""
      }
    }, [_vm._v("Select all that apply")]), _vm._v(" "), _vm._l((_vm.disciplines), function(discipline) {
      return _c('option', {
        attrs: {
          "disabled": mediaItem.disciplines.includes(discipline)
        }
      }, [_vm._v(_vm._s(discipline))])
    })], 2) : _vm._e(), _vm._v(" "), _c('ul', {
      staticClass: "disciplines"
    }, _vm._l((mediaItem.disciplines), function(discipline, $disciplineIndex) {
      return _c('li', [_vm._v("\n                            " + _vm._s(discipline) + " \n                            "), _c('div', {
        staticClass: "buttons"
      }, [_c('button', {
        staticClass: "remove-discipline",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.removeDiscipline(index, $disciplineIndex)
          }
        }
      }, [_vm._v("x")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs apply-to-all",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.applyDisciplineToAll(discipline)
          }
        }
      }, [_vm._v("Apply to All")])])])
    }))])])])
  })) : _c('div', {
    staticClass: "empty-area"
  }, [_c('p', [_vm._v("No media to show")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2186d987!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GalleryMediaListEditor.vue
// module id = 1970
// module chunks = 2